import gql from 'graphql-tag'

// """新建 Claim"""
export const newClaim = gql`
mutation($input: ClaimInput!) {
  newClaim(
    input: $input
  ){
    id
  }
}
`
// """编辑 Claim"""
export const editClaim = gql`
mutation($claimId: Int!,$input: ClaimInput!) {
  editClaim(
    claimId: $claimId,
    input: $input
  ){
    id
  }
}`

// """删除 Claim"""

export const deleteClaim = gql`
mutation($claimId: Int!) {
  deleteClaim(
    claimId: $claimId,
  )
}`

// """Policy Claim 列表"""

export const getClaimsOfPolicy = gql`
query($policyId: Int!) {
  getClaimsOfPolicy(
    policyId: $policyId
  ) {
    id
    totalAmount
    claimDate
    note
    createdAt
    updatedAt
    createdBy {
      username
    }
    lastModifiedBy {
      username
    }
    policy {
      policyName
      id
    }
  }
}
`

export const getClaimsOfAccount = gql`
query($accountId: Int!) {
  getClaimsOfAccount(
    accountId: $accountId
  ) {
    id
    totalAmount
    claimDate
    note
    createdAt
    updatedAt
    createdBy {
      username
    }
    lastModifiedBy {
      username
    }
    policy {
      policyName
      id
    }
  }
}
`
